class CartNotificationQuantity extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", (event) => {
      event.preventDefault();
      let num = document.querySelector('cart-notification-quantity[data-index="' + this.dataset.index + '"]').querySelector('input').value;
      const cartItems = this.closest("cart-notification");
      cartItems.updateQuantity(this.dataset.index, num);
    });
  }
}
customElements.define("cart-notification-quantity",CartNotificationQuantity);

class CartNotificationRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-notification");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-notification-remove-button",CartNotificationRemoveButton);


class CartNotificationPlusButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      let num = document.querySelector('cart-notification-quantity[data-index="' + this.dataset.index + '"]').querySelector('input').value;
      const cartItems = this.closest("cart-notification");
      cartItems.updateQuantity(this.dataset.index, parseInt(num) + 1);
    });
  }
}
customElements.define("cart-notification-plus-button",CartNotificationPlusButton);

class CartNotificationMinusButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      let num = document.querySelector('cart-notification-quantity[data-index="' + this.dataset.index + '"]').querySelector('input').value;
      const cartItems = this.closest("cart-notification");
      cartItems.updateQuantity(this.dataset.index, parseInt(num) - 1);
    });
  }
}
customElements.define("cart-notification-minus-button",CartNotificationMinusButton);

class CartNotification extends HTMLElement {

  updateCart(){
    let urlSections = window.location.pathname + '?sections=' + this.getSectionsToRender().map(item => item.id).join(',');
    fetch(urlSections)
    .then((response) => {
      return response.text();
    })
    .then((sections) => {
      const parsedSections = JSON.parse(sections);      
      this.getSectionsToRender()
        .forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedSections[section.id]
            );
        });
    });
  }
  
  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
          return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
  
        if(parsedState.errors !== undefined) {
          const errors =
              document.getElementById("cart-errors") ||
              document.getElementById("CartDrawer-CartErrors") ||
              document.querySelector('.serge-cart-notification-error');
          errors.textContent = parsedState.errors;
        }
        else 
        {
          this.getSectionsToRender()
              .forEach((section) => {
                  const elementToReplace = document.getElementById(section.id);
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                      parsedState.sections[section.id],
                      section.selector
                  );
              });
  
          // Clear errors UI
          const errors =
                document.getElementById("cart-errors") ||
                document.getElementById("CartDrawer-CartErrors") ||
                document.querySelector('.serge-cart-notification-error');
            errors.textContent = null;
        }
        
      })
      .catch((e) => {

          // Show the error
          const errors =
              document.getElementById("cart-errors") ||
              document.getElementById("CartDrawer-CartErrors") ||
              document.querySelector('.serge-cart-notification-error');
          errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        document.dispatchEvent(new CustomEvent("theme:cart:updated"));
      });
  }

  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.fader = document.querySelector(".cart-notification-fader");
    this.cartButton = document.querySelector("#bag-count-bubble");

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    this.querySelectorAll(".serge-cart-notification-close").forEach(
      (closeButton) =>
        closeButton.addEventListener("click", this.close.bind(this))
    );

    this.querySelectorAll(".serge-cart-notification-close").forEach(
      (closeFader) =>
        closeFader.addEventListener("click", this.close.bind(this))
    );

    this.cartButton.addEventListener("click", function (event) {
      event.preventDefault();

      if (window.location.href.indexOf("cart") > -1) {
        return;
      }

      setTimeout(() => {
        document.querySelector("cart-notification").open();
      });
    });

    // Fire using: document.dispatchEvent(new CustomEvent("theme:cart:update"));
    document.addEventListener('theme:cart:update', function(){
      this.updateCart();
    }.bind(this));
  }

  open() {
    this.notification.classList.add("animate", "active");
    this.fader.classList.add("active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    this.fader.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "serge-cart-notification-products",
        //selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      /*{
        id: 'cart-notification-button',
      },*/
      {
        id: "serge-cart-notification-footer",
      },
      {
        id: "bag-count-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
